import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {Scooters, ScootersData, Devices} from '../pages/layout/list-scooters/list-scooters.component';
import {BatteriesData} from '../pages/layout/list-batteries/list-batteries.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';


@Injectable({
  providedIn: 'root'
})
export class ScootersService {

  orgUrl = "";

  constructor(private afs: AngularFirestore) {
   }

  getScooters() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Scooters>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Scooters;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });;
  } 

  getScooterData(uid) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection+'/'+uid).snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as ScootersData;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  } 

  getBatteriesData(IMEI) {
    //console.log(IMEI);
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.doc('/devices/'+IMEI+'/SwapStn/Status').snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as BatteriesData;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }

  getDoorsData(IMEI,door_no) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.doc('/devices/'+IMEI+'/Batteries/'+door_no).snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as BatteriesData;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }
   getAllDoorsData(IMEI) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Devices>('devices'+'/'+IMEI+'/'+'Batteries').snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        const id = action.payload.doc.id;
        if(['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16'].includes(id)){
          try{
            if(action.payload.doc.data()['bms_param'].battery_id!=null){
              let str=action.payload.doc.data()['bms_param'].battery_id.toString();
                if(str.length>=4){
                  let strLastFour=str.substr(-4);
                  data['bms_param'].battery_id=strLastFour
                }
              }
          }catch{}
          return { id, ...data };
        }
      });
    });
  }
  getDeviceData() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Devices>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.DevicesCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Devices;
        const id = action.payload.doc.id;
        let charge = "No Info";
        if (data['state'] && data['state']['bms_param']) {
          charge = data['state']['bms_param'].rsoc + "%";
        }
        if(data.hasOwnProperty('state') && data['state'].hasOwnProperty('status')) {
          if(data['state']['status'] == 0) {
            data['state']['status'] = 'OFF';
          } else if (data['state']['status'] == 1) {
            data['state']['status'] = 'ON';
          } else if(data['state']['status'] == 2) {
            data['state']['status'] = 'EMERGENCY';
          } else { }
         }
        return { id, ...data, 'batteryCharge': charge };
        // if (data['DeviceType']!='' && data['DeviceType']!=undefined ) {
        //   return { id, ...data, 'batteryCharge': charge };
        // }
      });
    });
  }

  getDeviceDataForScooter(ScooterId) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Scooters>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.DevicesCollection, ref =>
    ref.where('ScooterId', '==',ScooterId)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Scooters;
        const id = action.payload.doc.id;
        let charge = "No Info";
        if (data['state'] && data['state']['bms_param']) {
          charge = data['state']['bms_param'].rsoc + "%";
        }
        if(data.hasOwnProperty('state') && data['state'].hasOwnProperty('status')) {
          if(data['state']['status'] == 0) {
            data['state']['status'] = 'OFF';
          } else if (data['state']['status'] == 1) {
            data['state']['status'] = 'ON';
          } else if(data['state']['status'] == 2) {
            data['state']['status'] = 'EMERGENCY';
          } else { }
         }
        return { id, ...data, 'batteryCharge': charge };
      });
    });
  }

  getScootersData(uid){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection+'/'+uid).snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as Scooters;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }

  getScooterByUser(username) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Scooters>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection, ref =>
    ref.where('UserID', '==',username)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Scooters;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });;  

  }

  getScooterByBattery(batteryId) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection, ref =>
    ref.where('BatteryID', '==',batteryId)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  getUnoccupiedScooters() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Scooters>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection, ref =>
    ref.where('UserID', '==',"")).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Scooters;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  editScooter(data,id) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection).doc(id).update(data).then(res => {}, err => reject(err));
  });
  
  }

  addScooter(data) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    data.RiderObj = {Name:'N/A'};
    data.BatteryObj = {};
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection).add(data).then(res => {
        this.editScooter({id: res.id, ...data}, res.id).then(res=>{});
        this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.DevicesCollection).doc(data.IMEI).set({"ScooterId":res.id},{merge:true});
        this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.RulesCollection).doc(res.id).set({});
        resolve(res);
      }, err => reject(err));
  });
  }

  deleteScooter(scooter) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ScootersCollection).doc(scooter.id).delete();
}

  updateSwapStnDoor(door_array, door_no,id) {
    //NOTE-NUMBER OF DOORS IN POWERHIVE AND BATTERYPOOL SWAPSTATION ARE DIFFERENT THEREFORE door_array is initialized in if else
    let updatedDoorArray=[...door_array];
    // let refreshDoorArray=[...door_array]
    updatedDoorArray[door_no] = 1;
  
    this.afs.doc('/devices/'+id.toString()).update({'state.door_status':[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}).then(res =>{
      this.afs.doc('/devices/'+id.toString()).update({'state.door_status':updatedDoorArray});
    }).catch(err => {
      // console.log('something went wrong '+ err)
    });
   
  }

  updateChargerStatus(chargerStatusList, door_no,id) {
      let OldChargerStatus=[...chargerStatusList]
      let updatedChargerStatus=[...chargerStatusList]

      if(updatedChargerStatus[door_no] == 0){
        updatedChargerStatus[door_no] = 1;
      } else {
        updatedChargerStatus[door_no] = 0;
      }

      this.afs.doc('/devices/'+id.toString()).update({'state.charger_status':OldChargerStatus}).then(res =>{
        this.afs.doc('/devices/'+id.toString()).update({'state.charger_status':updatedChargerStatus});
      }).catch(err => {
        // console.log('something went wrong '+ err)
      });
  }

  updateChargerStatusList(chargerStatusList,id) {
    this.afs.collection('devices').doc(id.toString()).update({'state.charger_status': chargerStatusList});
  }

}
